export default __webpack_public_path__ + "static/media/pause.c3779957.svg";